export default __webpack_public_path__ + "static/media/Deacon's Bracers of the Eighteen Pits.fa42666e.jpg";